/**
 * 通用翻译 - 中文
 * 包含：公共操作词、布局、登录、标签页、系统标题
 */
export default {
  common: {
    add: '新增',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    cancel: '取消',
    confirm: '确定',
    default: '默认',
    setAsDefault: '设为默认',
    search: '搜索',
    searchPlaceholder: '请输入关键词搜索',
    select: '请选择',
    selectProduct: '选择商品',
    available: '可开票',
    reset: '重置',
    clear: '清除',
    export: '导出',
    import: '导入',
    print: '打印',
    refresh: '刷新',
    operation: '操作',
    actions: '操作',
    status: '状态',
    remark: '备注',
    success: '操作成功',
    failed: '操作失败',
    loading: '加载中...',
    noData: '暂无数据',
    yes: '是',
    no: '否',
    all: '全部',
    enable: '启用',
    disable: '停用',
    submit: '提交',
    back: '返回',
    close: '关闭',
    view: '查看',
    detail: '详情',
    viewAll: '查看全部',
    tip: '提示',
    more: '更多',
    batchDelete: '批量删除',
    createTime: '创建时间',
    updateTime: '更新时间',
    startDate: '开始日期',
    endDate: '结束日期',
    to: '至',
    name: '名称',
    code: '编码',
    type: '类型',
    description: '描述',
    sort: '排序',
    phone: '手机号',
    email: '邮箱',
    unlimited: '不限',
    pleaseSelect: '请选择',
    pleaseInput: '请输入',
    address: '地址',
    area: '面积',
    floor: '楼层',
    selectPlaceholder: '请选择',
    inputPlaceholder: '请输入',
    autoGenerate: '系统自动生成',
    selectDate: '选择日期',
    required: '必填',
    deleteConfirm: '确定要删除吗？此操作不可恢复。',
    deleteTitle: '删除确认',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    refreshSuccess: '刷新成功',
    refreshFailed: '刷新失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    submitSuccess: '提交成功',
    submitFailed: '提交失败',
    operationSuccess: '操作成功',
    operationFailed: '操作失败',
    noPermission: '无权限',
    total: '共 {total} 条',
    selected: '已选择 {count} 项',
    normal: '正常',
    enabled: '启用',
    disabled: '禁用',
    pending: '待处理',
    approved: '已通过',
    rejected: '已驳回',
    draft: '草稿',
    active: '生效',
    terminated: '已终止',
    expired: '已过期',
    unknown: '未知',
    year: '年',
    month: '月',
    day: '日',
    yuan: '元',
    squareMeter: '㎡',
    resetPassword: '重置密码',
    resetPasswordConfirm: '确定要重置该用户的密码吗？',
    resetPasswordSuccess: '密码重置成功',
    // 动态表单辅助
    inputPrefix: '请输入',
    selectPrefix: '请选择',
    cannotBeEmpty: '不能为空',
    remarkPlaceholder: '请输入备注',
    warning: '警告',
    addSuccess: '新增成功',
    createSuccess: '创建成功',
    editSuccess: '编辑成功',
    updateSuccess: '修改成功',
    featureDeveloping: '功能开发中',
    // 分页和全屏
    seq: '序号',
    fullscreen: '全屏',
    exitFullscreen: '退出全屏',
    prev: '上一步',
    next: '下一步',
    downloadSuccess: '下载成功',
    downloadFailed: '下载失败',
    comingSoon: '即将推出',
    selectDate: '选择日期',
    hideSearch: '收起搜索',
    showSearch: '展开搜索',
    creator: '创建人',
    lastUpdate: '最后更新',
  },

  theme: {
    light: '浅色模式',
    dark: '暗色模式',
    system: '跟随系统',
  },

  layout: {
    home: '首页',
    logout: '退出登录',
    profile: '个人中心',
    settings: '系统设置',
    logoutConfirm: '确定要退出登录吗？',
    tip: '提示',
    menuLoading: '加载菜单中...',
    brandName: '函云双子星智算平台',
    collapseMenu: '点击收起菜单',
    expandMenu: '点击展开菜单',
    menuSearch: {
      shortcut: 'Ctrl+K',
      placeholder: '搜索菜单...',
      noResult: '未找到匹配的菜单',
      navigate: '导航',
      confirm: '确认',
      close: '关闭',
    },
  },

  login: {
    title: '账号登录',
    username: '用户名',
    password: '密码',
    login: '登 录',
    remember: '记住密码',
    forgotPassword: '忘记密码？',
    welcomeTitle: '欢迎回来',
    welcome: '登录双子星平台，继续你的工作',
    helpPrefix: '遇到账号问题？',
    helpAction: '联系系统管理员',
    chipCompute: '算力利用率',
    chipTasks: '在线推理任务',
    brandSubtitle: 'AI-Driven Retail Intelligence Platform',
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入密码',
    selectOrg: '请选择登录组织',
    captchaPlaceholder: '请输入验证码',
    captcha: '验证码',
    clickToGet: '点击获取',
    loggingIn: '登录中...',
    featureSecurity: '安全可靠',
    featureEfficiency: '高效运营',
    featureInsight: '数据洞察',
    copyright: '© 2026 函云双子星 · Alayadata',
    usernameRequired: '请输入用户名',
    usernameLength: '请输入 3-50 位用户名',
    usernamePattern: '用户名只能包含字母、数字和下划线',
    passwordRequired: '请输入密码',
    passwordLength: '请输入 6-50 位密码',
    passwordPattern: '密码包含不允许的字符',
    orgRequired: '请选择登录组织',
    captchaRequired: '请输入验证码',
    captchaLength: '请输入 4 位验证码',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    loginError: '登录异常，请稍后重试',
  },

  tagsView: {
    refresh: '刷新当前页',
    close: '关闭当前',
    closeOther: '关闭其他',
    closeLeft: '关闭左侧',
    closeRight: '关闭右侧',
    closeAll: '关闭全部',
  },

  profile: {
    title: '个人中心',
    basicInfo: '基本信息',
    changePassword: '修改密码',
    username: '用户名',
    realname: '姓名',
    email: '邮箱',
    phone: '手机号',
    gender: '性别',
    genderMale: '男',
    genderFemale: '女',
    genderUnknown: '未知',
    dept: '部门',
    org: '组织',
    role: '角色',
    avatar: '头像',
    changeAvatar: '更换头像',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    currentPasswordRequired: '请输入当前密码',
    newPasswordRequired: '请输入新密码',
    confirmPasswordRequired: '请确认新密码',
    passwordMismatch: '两次输入的密码不一致',
    passwordChanged: '密码修改成功，请重新登录',
    profileUpdated: '个人资料已更新',
    avatarUpdated: '头像已更新',
    avatarUploadFailed: '头像上传失败',
    passwordStrength: '密码强度',
    strengthWeak: '很弱',
    strengthLow: '弱',
    strengthMedium: '中',
    strengthStrong: '强',
    passwordRule: '密码需8-32位，包含字母和数字',
    adminCannotChangePassword: '系统管理员密码不支持在此修改，请联系超级管理员',
  },

  system: {
    title: '函云双子星智算平台 1.0 · Alayadata',
  },
}
